export const minimise_alt = () => (
  <path
    d="M18 11V5a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2h6m4 3h6m0 0v-6m0 6L10 10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
